import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import History from "./History";

import { AppState } from "../../../../store";
import {
  getItemById as getItem,
  fetchHistory,
} from "../../../../store/prescription/actions";

import PrescriptionInterface from "../../../../interfaces/prescription";

interface StateProps {
  prescription: PrescriptionInterface;
  mustUpdateHistory: boolean;
}

interface DispatchProps {
  getItemById: Function;
}

type Props = StateProps & DispatchProps;

const HistoryContainer: React.FC<Props> = ({
  getItemById,
  mustUpdateHistory,
  prescription,
}: Props) => {
  const dispatch = useDispatch();
  const { history, historyLoading, historyError } = useSelector(
    (state: AppState) => ({
      history: state.prescription.history,
      historyLoading: state.prescription.historyLoading,
      historyError: state.prescription.historyError,
    }),
  );

  useEffect(() => {
    if (mustUpdateHistory) {
      dispatch(fetchHistory(prescription.token));
    }
  }, [mustUpdateHistory, prescription.token, dispatch]);

  return (
    <History
      items={history}
      error={historyError}
      loading={historyLoading}
      getItemById={getItemById}
    />
  );
};

const mapStateToProps = ({ prescription }: AppState): StateProps => ({
  prescription: prescription.prescription,
  mustUpdateHistory: prescription.mustUpdateHistory,
});

const mapDispatchToProps = {
  getItemById: getItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryContainer);
